import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  Button,
  CustomInput,
  Description,
  Title,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { useForgotPasswordMutation } from "../../Data/services/userAuthApi";
import Toast from "../../Hooks/useToast";
import { ACCOUNT_ENUM } from "./Route";
import { BeatLoader, ClipLoader } from "react-spinners";

export default function ForgotPassword({ setPage }) {
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  // const isLoading = true;
  // console.log(isLoading, "isLoading");

  const watchEmail = watch("email", "");

  const handleBackButtonClick = () => {
    setPage(ACCOUNT_ENUM.LOGIN);
  };

  const [forgetPassword, { isError, isLoading, isSuccess }] =
    useForgotPasswordMutation();

  const handleDataSubmit = async (userData) => {
    try {
      const response = await forgetPassword(userData);
      if (response.data.code === 200) {
        Toast(response?.data.message, "success");

        // navigate(WEB_ROUTES.ACCOUNT);
        setPage(ACCOUNT_ENUM.LOGIN);
      }
    } catch (error) {
      // console.log(error.data.message, 'errrrr');
      if (error.data && error.data.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <AccountLayout
      hasBackButton={true}
      handleBackButton={handleBackButtonClick}
    >
      {errors
        ? errors.email?.message
          ? Toast(errors.email?.message, "error")
          : null
        : null}
      <Title text="Forgot Password" classes="mb-2 " />
      <Description
        text="In order to reset your password you need to enter your registered email address."
        classes="text-center fs-7"
      />
      <Form onSubmit={handleSubmit(handleDataSubmit)}>
        <Controller
          control={control}
          name="email"
          rules={{
            required: "Email is required.",
            pattern: {
              value: /\S+@\S+\.\S+/,
              message: "Enter a valid email address.",
            },
          }}
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
                value={value}
                onBlur={onBlur}
              />
            </InputGroup>
          )}
        />
        <Button
          // text={"Continue"}
          text={
            isLoading ? <ClipLoader color="#0f0f0f" size="22px" /> : "Continue"
          }
          classes={`mt-3 mb-2 ${
            !watchEmail || isLoading ? "bg-dark-subtle" : "shadow"
          } `}
          disabled={isLoading || !watchEmail}
          type="submit"
        />
      </Form>
    </AccountLayout>
  );
}
